import createAxiosInstance, { promiseTimeout } from "../axiosClient"

export async function getProdutos(empresa_padrao: number, token: string) {
    const axiosClient = await createAxiosInstance()
    const request = axiosClient.get(`/carregar/produto/${empresa_padrao}`, {
        headers: {'x-access-token': token}
    })
    return promiseTimeout(request)
}